import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import {
  getAuth,
  signInAnonymously,
  connectAuthEmulator,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCHE3tj84U71iWDq7cZL6d0SvTbdHUKyo8',
  authDomain: 'partydecider.com',
  projectId: 'project2025-e2ea0',
  storageBucket: 'project2025-e2ea0.firebasestorage.app',
  messagingSenderId: '311855300509',
  appId: '1:311855300509:web:f619fc5c27ccb9d5377974',
  measurementId: 'G-174CZTY5X2',
};

const metaEnv = (() => {
  if (typeof import.meta !== 'undefined' && import.meta?.env) {
    return import.meta.env;
  }
  if (typeof process !== 'undefined' && process?.env) {
    return process.env;
  }
  return {};
})();

export const emulatorConfig = {
  useEmulators: metaEnv.VITE_USE_EMULATORS === 'true',
  firestoreHost: metaEnv.VITE_FIRESTORE_EMULATOR_HOST || '127.0.0.1',
  firestorePort: Number(metaEnv.VITE_FIRESTORE_EMULATOR_PORT || 8080),
  authHost: metaEnv.VITE_AUTH_EMULATOR_HOST || '127.0.0.1',
  authPort: Number(metaEnv.VITE_AUTH_EMULATOR_PORT || 9099),
  functionsHost: metaEnv.VITE_FUNCTIONS_EMULATOR_HOST || '127.0.0.1',
  functionsPort: Number(metaEnv.VITE_FUNCTIONS_EMULATOR_PORT || 5001),
};

export const app = initializeApp(firebaseConfig);

export let analytics = null;
try {
  isSupported()
    .then((supported) => {
      if (supported) analytics = getAnalytics(app);
    })
    .catch(() => {
      /* ignore analytics errors in non-browser environments */
    });
} catch {
  /* no-op */
}

export const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence).catch((err) => {
  console.warn('[Firebase] Failed to set auth persistence:', err);
});

if (emulatorConfig.useEmulators) {
  try {
    connectAuthEmulator(auth, `http://${emulatorConfig.authHost}:${emulatorConfig.authPort}`);
  } catch (err) {
    console.warn('[Firebase] Failed to connect auth emulator:', err);
  }
}

export async function ensureAnonymousAuth() {
  if (auth.currentUser) return auth.currentUser;
  try {
    const credential = await signInAnonymously(auth);
    return credential.user ?? auth.currentUser;
  } catch (err) {
    console.error('[Firebase] Anonymous auth failed:', err);
    throw err;
  }
}
